import { plugin, Mode } from 'light-component';
import { useTranslation } from '@common';
import { Thumbnail } from '../../component';
import { WidgetKind, WidgetType } from '../types';
import { TextAreaDesignMode } from './design';
import { TextAreaInputMode } from './input';
import { TextAreaViewMode } from './view';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function ShortAnswer(props: TextAreaProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesShortAnswerIcon' title={t('ShotEyesShortAnswer')} toolTipContent={t('简答题')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<TextAreaDesignMode {...props} initTitle={t('ShotEyesShortAnswer')} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<TextAreaViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<TextAreaInputMode {...props} />);
  }

  return null;
}

ShortAnswer.prototype.type = WidgetType.SHOTEYES_SHORT_ANSWER;
plugin.register({ kind: WidgetKind.WIDGET, component: ShortAnswer });
